import type { SsoAppStatus, SsoConnStatus } from '@/api/sso'

const META: Record<SsoConnStatus | SsoAppStatus, { label: string; color: string }> = {
  draft: { label: 'Rascunho', color: 'gray' },
  testing: { label: 'Provisionando', color: 'inovareTeal' },
  active: { label: 'Ativo', color: 'green' },
  paused: { label: 'Pausado', color: 'yellow' },
  error: { label: 'Erro', color: 'red' },
  deleting: { label: 'Excluindo', color: 'gray' },
}

export function ssoStatusMeta(status: SsoConnStatus | SsoAppStatus): { label: string; color: string } {
  return META[status]
}
